import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import { CloseIcon } from './PartnershipCertificateDialog.styles'

/**
 * The header PartnershipCertificateDialog' component.
 */
const Header = props => {
  const { idSTU, isSTU, onClickClose } = props
  return (
    <>
      <CloseIcon onClick={onClickClose} />
      <Typography
        color="black1"
        fontSize="27px"
        fontWeight="light"
        margin={!isSTU ? '0 0 20px' : undefined}
        variant="h1"
      >
        Socios y accionistas principales
      </Typography>
      {isSTU && (
        <Typography color="black1" fontSize="16px" fontWeight="light" lineHeight="25px" margin="0 0 20px" variant="h2">
          Unión temporal de proveedores ID: {idSTU}
        </Typography>
      )}
    </>
  )
}

Header.defaultProps = {
  idSTU: null,
  isSTU: false
}

Header.propTypes = {
  idSTU: PropTypes.number,
  isSTU: PropTypes.bool,
  onClickClose: PropTypes.func.isRequired
}

export default Header
